import { useMediaReadiness } from "@repo/conferencing/components";
import type { PortalProfile } from "@repo/edge/types";
import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet, redirect, useRouterState } from "@tanstack/react-router";
import { PortalShell } from "@/app/shell/portal-shell";
import { session } from "@/shared/edge/session";

interface RouterContext {
  profile: PortalProfile | undefined;
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  beforeLoad: async ({ location }) => {
    // Skip auth check for login page
    if (location.pathname === "/login") {
      return;
    }
    const profile = session.getProfile();
    if (!profile) {
      throw redirect({
        to: "/login",
        search: {
          redirect: location.href,
        },
      });
    }
  },
  component: RootComponent,
});

function RootComponent() {
  useMediaReadiness();
  const { profile } = Route.useRouteContext();
  const location = useRouterState({ select: (s) => s.location });

  // Login renders bare, without the app chrome.
  if (location.pathname === "/login") {
    return <Outlet />;
  }

  return <PortalShell profile={profile} />;
}
